import tween from './tween';

export default (duration, onComplete) => tween({ duration, onComplete });
